var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.93,16.07A48,48,0,0,1,50,98V86A36,36,0,0,0,75.45,24.55l-9.84,9.84A2.11,2.11,0,0,1,62,32.9V5a3,3,0,0,1,3-3H92.9a2.11,2.11,0,0,1,1.49,3.61ZM50,14V2A48,48,0,0,0,16.07,83.93L5.71,94.29A2.17,2.17,0,0,0,7.25,98H35a3,3,0,0,0,3-3V67.25a2.17,2.17,0,0,0-3.71-1.54l-9.74,9.74A36,36,0,0,1,50,14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.3f87e585ad685e95f548ea3304c6bdf5.svg";
export { ForwardRef as ReactComponent };